import React from 'react';
import { Network, Settings, Calculator, MessageCircle, CheckCircle, Briefcase } from 'lucide-react';
import { valuePropositions } from '../mock';

const iconMap = {
  network: Network,
  settings: Settings,
  calculator: Calculator,
  'message-circle': MessageCircle,
  'check-circle': CheckCircle,
  briefcase: Briefcase
};

const ValueProps = () => {
  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-4xl md:text-5xl font-bold">
            Why{' '}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              SystemCraft?
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Practice system design the way it's tested in real interviews
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 stagger-children">
          {valuePropositions.map((prop, index) => {
            const Icon = iconMap[prop.icon];
            return (
              <div
                key={index}
                className="group p-8 bg-gradient-to-br from-gray-900/50 to-gray-800/30 border border-gray-800 rounded-xl hover:border-cyan-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10 hover:-translate-y-1 hover-lift"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 rounded-lg flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-6 h-6 text-cyan-400" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">{prop.title}</h3>
                <p className="text-gray-400 leading-relaxed">{prop.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
